var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.75963C0 0.787812 0.787813 0 1.75963 0H12.2404C13.2122 0 14 0.787813 14 1.75963C14 2.42818 13.7463 3.07182 13.2901 3.56057L9.63789 7.47369C9.29224 7.84403 9.1 8.33174 9.1 8.83833V11.282C9.1 11.6607 8.886 12.007 8.54721 12.1764L6.34721 13.2764C5.68231 13.6088 4.9 13.1253 4.9 12.382V8.83833C4.9 8.33174 4.70776 7.84403 4.36211 7.47369L0.709865 3.56057C0.2537 3.07182 0 2.42818 0 1.75963Z",
    fill: "#EDA30E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1ca424cd1f0638d6908ffd32f43c8d6d.svg";
export { ForwardRef as ReactComponent };